import { NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from '@core/guards/module-import.guard';
import { NavViewModule } from '@app/features/nav-view/nav-view.module';
import { NavAutomationModule } from '@app/features/nav-automation/nav-automation.module';
import { DeviceModule } from '@app/features/device-health/device.module';
import { LocationModule } from '@app/features/locations/modules/location/location.module';
import { ChainWideMerakisModule } from '@app/features/merakis/modules/chain-wide-merakis/chain-wide-merakis.module';
import { ChainWideCradlepointsModule } from '@app/features/cradlepoints/modules/chain-wide-cradlepoints/chain-wide-cradlepoints.module';
import { ChainWideFortigatesModule } from '@app/features/fortigates/modules/chain-wide-fortigates/chain-wide-fortigates.module';
import { ChainWideMistsModule } from '@app/features/mists/modules/chain-wide-mists/chain-wide-mists.module';
import { ChainHealthModule } from '@app/features/chain-health/modules/chain-health/chain-health.module';
import { WanModule } from '@app/features/wan/modules/wan-health/wan-health.module';
import { LanModule } from '@app/features/lan/modules/lan-health/lan-health.module';
import { WifiModule } from '@app/features/wifi/modules/wifi-health/wifi-health.module';
import { DatadogModule } from '@app/features/datadog/modules/datadog-dashboard/datadog.module';
import { LumenDiagnosticsModule } from '@app/features/lumen-diagnostics/lumen-diagnostics.module';
import { FortinetMetricsModule } from '@app/features/fortinet-metrics/fortinet-metrics.module';
import { AvailabilityModule } from '@app/features/metrics/modules/availability/availability.module';
import { CpSpeedTestsModule } from '@app/features/metrics/modules/cp-speed-tests/cp-speed-tests.module';
import { CircuitMapModule } from '@app/features/circuit-map/circuit-map.module';
import { Kevlar2ProgressModule } from '@app/features/metrics/modules/kevlar2-progress/kevlar2-progress.module';
import { NetworkTagsModule } from '@app/features/merakis/modules/network-tags/network-tags.module';
import { MerakiAdminAuditModule } from '@app/features/merakis/modules/meraki-admin-audit/meraki-admin-audit.module';
import { MerakiGoProvisioningModule } from '@app/features/merakis/modules/meraki-go-provisioning/meraki-go-provisioning.module';
import { RogueAccessPointsModule } from '@app/features/mists/modules/rogue-ap-audit/rogue-ap-audit.module';
import { MistGuestWifiModule } from '@app/features/mists/modules/guest-wifi/guest-wifi.module';
import { SiteAuditModule } from '@app/features/site-audit/site-audit.module';
import { ChainAuditModule } from '@app/features/chain-audit/chain-audit.module';
import { CradlepointProvisioningModule } from '@app/features/cradlepoints/modules/cradlepoint-provisioning/cradlepoint-provisioning.module';
import { Kevlar2ValidationModule } from '@app/features/kevlar2-validation/kevlar2-validation.module';
import { Kevlar2ConfigModule } from '@app/features/kevlar2-config/kevlar2-config.module';
import { FortigateProvisioningModule } from '@app/features/fortigates/modules/fortigate-provisioning/fortigate-provisioning.module';
import { SiteIpInfoModule } from '@app/features/site-ip-info/site-ip-info.module';
import { ErrorsModule } from '@app/features/errors/errors.module';

@NgModule({
    imports: [
        NavViewModule,
        NavAutomationModule,
        DeviceModule,
        LocationModule,
        ChainWideMerakisModule,
        ChainWideCradlepointsModule,
        ChainWideFortigatesModule,
        ChainWideMistsModule,
        ChainHealthModule,
        WanModule,
        LanModule,
        WifiModule,
        DatadogModule,
        LumenDiagnosticsModule,
        FortinetMetricsModule,
        AvailabilityModule,
        CpSpeedTestsModule,
        CircuitMapModule,
        Kevlar2ProgressModule,
        NetworkTagsModule,
        MerakiAdminAuditModule,
        MerakiGoProvisioningModule,
        RogueAccessPointsModule,
        MistGuestWifiModule,
        SiteAuditModule,
        ChainAuditModule,
        CradlepointProvisioningModule,
        Kevlar2ValidationModule,
        Kevlar2ConfigModule,
        FortigateProvisioningModule,
        SiteIpInfoModule,
        ErrorsModule
    ],
    exports: [],
    declarations: [],
    providers: [],
    schemas: []
})
export class FeaturesModule {
    constructor(@Optional() @SkipSelf() parentModule: FeaturesModule) {
        throwIfAlreadyLoaded(parentModule, 'FeaturesModule');
    }
}
